import { render, staticRenderFns } from "./ActivityReceipt.vue?vue&type=template&id=16907310&scoped=true&"
import script from "./ActivityReceipt.vue?vue&type=script&lang=js&"
export * from "./ActivityReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ActivityReceipt.vue?vue&type=style&index=0&id=16907310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16907310",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
